import type { TBankAccount } from '@shared/types/bank-account';
import type { TEwallet } from '@shared/types/ewallet';
import { number, object, string } from 'yup';
import type { IInitialBankValues, IInitialEWalletValues } from './interfaces';

export const validationSchema = object({
  bank_name: string().required('Bank Name is required'),
  account_number: number().required('Account number is required'),
  beneficiary_name: string().required('Name is required'),
  address_line_1: string().required('Address is required'),
  city: string(),
  country: string(),
  state: string(),
  postal_code: string(),
  swift_code: string().required('Swift code is required'),
  iban: string().nullable(),
  currency: string().required('Currency is required'),
});

export const eWalletValidationSchema = object({
  logo: string().nullable(),
  provider_name: string().required('Wallet is required'),
  recipient_name: string().required('Recipient Name is required'),
  recipient_number: string().required('Recipient Number is required'),
});

export const generateInitialValuesForBank = (
  bank?: TBankAccount
): IInitialBankValues => {
  return {
    id: bank?.id,
    bank_name: bank?.bank_name || '',
    account_number: bank?.account_number || '',
    beneficiary_name: bank?.beneficiary_name || '',
    address_line_1: bank?.address_line_1 || '',
    address_line_2: bank?.address_line_2 || '',
    city: bank?.city || '',
    country: bank?.country.code || '',
    state: bank?.state || '',
    postal_code: bank?.postal_code || '',
    swift_code: bank?.swift_code || '',
    iban: bank?.iban || '',
    currency: bank?.currency || '',
    logo: typeof bank?.logo === 'string' ? bank.logo : null,
  };
};

export const generateInitialEWalletValues = (
  wallet?: TEwallet
): IInitialEWalletValues => ({
  provider_name: wallet?.provider_name || '',
  recipient_name: wallet?.recipient_name || '',
  recipient_number: wallet?.recipient_number || '',
  logo: wallet?.logo,
});
